export type Area = {
  id: number;
  juki_id: number;
  content: string;
  start: string;
  end: string;
  belong: string;
  director: string;
  contact: string;
  note: string;
  color: string;
  width: number;
  height: number;
  position: { top: number; left: number };
};
